import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

import { connect } from 'react-redux';
import CurrentDispatchPage from './CurrentDispatchPage';
import MapContainer from '../MapContainer';

const DispatchesPage = props => (
  <Fragment>
    {props.map.loaded ? (
      <Fragment>
        <Route path="/dispatches" component={CurrentDispatchPage} />
      </Fragment>
    ) : null}
    <div
      className="map-col-hidden"
      style={{
        display: props.map.mapColumnVisible ? '' : 'none'
      }}
    >
      <MapContainer />
    </div>
  </Fragment>
);


const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config
});
export default connect(mapStateToProps)(DispatchesPage);



// WEBPACK FOOTER //
// ./src/components/dispatches/DispatchesPage.js